'use strict';

const EVENT_RELOAD_NOTIFICATIONS = 'eventReloadNotifications';
const ESTRATEGIA_SYNC_PADRAO = 'aqila-api';

// eslint-disable-next-line max-params, max-lines-per-function
angular.module('webAgro1App').controller('BaseCtrl', function($rootScope, $q, $location, Lightbox, $uibModal,
  $route, $scope, ApiGlobalService, StorageService, SafrasService, PropriedadesService, MapaPropriedadeService,
  LoadingService, UsuariosService, PermissionsService, NotificacoesService, RecomendacoesService, MessagesService,
  filterFilter, AuditoriaAplicacaoService, LoadGoogleMapsService, ParametrosService, ContratoService, $routeParams,
  $timeout, $cookies, ItensEstoqueService, UnidadesService, $uibModalStack, DAYS_SHOW_RENOVATION) {
  $rootScope.isDevelopment = typeof PRODUCTION === 'undefined';

  $rootScope.filterNotifications = '';
  $scope.filterProperty = '';

  // eslint-disable-next-line complexity
  $scope.filterNotificationsList = function(value) {
    return [
      value.propriedade.descricao.toLowerCase(),
      ((value.cultura || {}).descricao || '').toLowerCase(),
      ((value.atividade || {}).descricao || '').toLowerCase(),
      ((value.gleba || {}).descricao || '').toLowerCase(),
      (value.tipo_operacao || 'Recomendação').toLowerCase()
    ].find((item) => item.includes($scope.$root.filterNotifications.toLowerCase()));
  };

  const loadContrato = async function() {
    try {
      const [
        { data: contratoMensagens },
        { data: contrato }
      ] = await Promise.all([
        ContratoService.messages(),
        ContratoService.get()
      ]);

      // Armazena em local storage o código GPA para aqila 2
      if (contrato && contrato.codigo) {
        localStorage['api::l_s'] = contrato.codigo;
      }

      $scope.contratoMensagens = contratoMensagens;
      $scope.daysRemainingContract = moment(contrato.data_vencimento_contrato)
        .diff(moment().format('YYYY-MM-DD'), 'day');
      $scope.daysToBlockContract = contrato.dias_para_bloqueio;
    } catch (error) {
      console.error('Erro ao carregar contrato', error);
      MessagesService.alert('Erro ao carregar contrato');
    }
  };

  // eslint-disable-next-line max-lines-per-function
  const loadNotificacoes = async function() {
    try {
      const { data: notificacoes } = await NotificacoesService.list();
      notificacoes.aplicacoes.forEach((aplicacao) => {
        const auditoriaAplicacao = aplicacao.auditoria_aplicacao;
        if (auditoriaAplicacao && _.isString(auditoriaAplicacao.objeto)) {
          auditoriaAplicacao.objeto = JSON.parse(auditoriaAplicacao.objeto);
          const dataInicial =
            auditoriaAplicacao.objeto.iniciado_em ||
            auditoriaAplicacao.dt_ini ||
            auditoriaAplicacao.dataInicio ||
            auditoriaAplicacao.objeto.dataInicio;
          aplicacao.created_at = moment(dataInicial).toDate();
        }
      });

      notificacoes.aplicacoes = _.orderBy(notificacoes.aplicacoes, 'created_at');

      $scope.notificacoes = notificacoes;

      $rootScope.$apply();
    } catch (error) {
      console.error('Erro ao carregar notificações', error);
      MessagesService.alert('Erro ao carregar notificações');
    }
  };

  $scope.reloadNotificacoes = function($event) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    $scope.loadingNotificacoes = true;
    loadNotificacoes().finally(() => {
      $scope.loadingNotificacoes = false;
      $scope.$applyAsync();
    });
  };

  const loadRenewalManager = async function() {
    $rootScope.exibirPainelErrosIntegracao = false;
    try {
      const customer = await ApiGlobalService.getRenewalManager();

      $scope.renewalManager = {
        name: customer.contract_renewal_manager,
        email: customer.contract_renewal_email
      };

      $rootScope.exibirPainelErrosIntegracao = customer.consult_saldo_estoque_strategy !== ESTRATEGIA_SYNC_PADRAO;
    } catch (error) {
      console.error('Erro ao carregar responsável renovacao contrato', error);
    }
  };

  const showModalContractRenovation = function() {
    if (!$scope.renewalManager || $rootScope.parametros.renovacao_contrato_respondida) {
      return;
    }
    return $scope.currentUser.email === $scope.renewalManager.email &&
     $scope.daysRemainingContract <= DAYS_SHOW_RENOVATION;
  };

  // eslint-disable-next-line max-lines-per-function
  $rootScope.initWeb = function() {
    const loggedIn = StorageService.get(KEY_USER);
    if (!loggedIn) {
      return;
    }

    ContratoService.contractStatus().then(function(result) {
      if (result.data.invalid) {
        $rootScope.contractInvalid = true;

        $location.path('/expired');
        LoadingService.hideLoading();
        return false;
      }

      return true;
    })
      // eslint-disable-next-line max-lines-per-function
      .then(function(ok) {
        if (ok) {
          loadNotificacoes();
          loadContrato();
          loadRenewalManager();
          const promises = [
            SafrasService.list({ all: true }),
            PropriedadesService.list(),
            UsuariosService.listUsuario((StorageService.get(KEY_USER) || {}).id),
            ParametrosService.get(),
            UnidadesService.all_with_conversions()
          ];
          if (!window.google || !window.google.maps) {
            promises.push(LoadGoogleMapsService.load());
          }

          // eslint-disable-next-line max-lines-per-function, complexity
          $q.all(promises).then(function(results) {
            $rootScope.safras = results[0].data;
            $rootScope.propriedades = results[1].data;
            $rootScope.permissions = PermissionsService.get((results[2].data.funcao || {}).permissions || []);
            $rootScope.parametros = results[3].data.parametros || {};
            $rootScope.unidadesWithConversions = results[4].data;
            if (results[3].data.imagem && results[3].data.imagem.imagem_report_url) {
              $rootScope.parametros.imagem_report_url = SERVER + results[3].data.imagem.imagem_report_url;
            }

            $rootScope.propriedades.forEach(function(propriedade) {
              propriedade.map = MapaPropriedadeService.getPropertyMap(propriedade);
            });

            const propriedadeUrl = $location.search().propriedade;

            const isSamePropriedade = !!$rootScope.currentPropriedade && (
              $rootScope.currentPropriedade.id === +propriedadeUrl ||
              $rootScope.currentPropriedade.uuid === propriedadeUrl
            );

            if (propriedadeUrl && !isSamePropriedade) {
              $rootScope.setPropriedade(isNaN(+propriedadeUrl) ? propriedadeUrl : +propriedadeUrl);
            } else if (!propriedadeUrl && !$rootScope.currentPropriedade) {
              try {
                const storedPropriedadeRaw = localStorage.getItem(KEY_CURRENT_PROPRIEDADE);
                const storedPropriedade = storedPropriedadeRaw && JSON.parse(storedPropriedadeRaw);
                const found = storedPropriedade && $rootScope.getPropriedade(storedPropriedade.id);
                if (found && found.id) {
                  if ($location.search().redirectTo) {
                    $rootScope.setPropriedade(found);
                  } else {
                    $rootScope.currentPropriedade = found;
                  }
                }
              } catch (error) {
                console.error('Erro ao restaurar propriedade do localStorage', error);
              }
            }

            if (!loggedIn.cpf) {
              const hasAsked = $cookies.get('cpfCheck');
              if (!hasAsked) {
                const modal = $uibModal.open({
                  templateUrl: 'views/usuarios/preencher-cpf-modal.html',
                  controller: 'CpfLoginUnificadoCtrl as $ctrl'
                });

                modal.result.catch(() => {
                  $cookies.put('cpfCheck', true, {
                    expires: moment().add(1, 'day')
                      .toDate()
                  });
                });
              }
            }

            if (showModalContractRenovation()) {
              const modalScope = $rootScope.$new();
              modalScope.daysRemainingContract = $scope.daysRemainingContract;

              $uibModal.open({
                templateUrl: 'views/usuarios/renovar-contrato-automaticamente.html',
                controller: 'RenovarContratoAutomaticamenteCtrl as $ctrl',
                scope: modalScope
              });
            }

            $rootScope.initializePromise.resolve({
              propriedades: $rootScope.propriedades,
              safras: $rootScope.safras
            });
          }, function(e) {
            $rootScope.initializePromise.reject(e);
          });
        }
      })
      .catch((error) => $rootScope.initializePromise.reject(error));
  };

  /**
   * Resets variables initialized by $rootScope.initWeb function
   * Also resets predefined promises as the value wasn't updating accordingly
   */
  $rootScope.resetWeb = function() {
    // resets $rootScope initializePromise & initialize
    $rootScope.initializePromise = $q.defer();
    $rootScope.initialize = $rootScope.initializePromise.promise;
    // reset $rootScope variables
    // avoids flash of old loaded content
    if ($rootScope.propriedades) {
      $rootScope.propriedades.length = 0;
      $rootScope.safras.length = 0;
    }
    $rootScope.permissions = {};
    $rootScope.parametros = {};
    $route.updateParams({});
  };

  $scope.reload = function($event) {
    loadNotificacoes();
    loadContrato();

    if ($event) {
      $event.preventDefault();
    }

    /* Deleta mapa da propriedade */
    if (document.getElementById('main_map')) {
      document.getElementById('main_map').outerHTML = '';
    }

    if ($route.current.originalPath === '/propriedade') {
      const params = {};
      for (const key in $routeParams) {
        params[key] = null;
      }
      $route.updateParams(params);
    }

    $route.reload();
    $scope.$broadcast('routeReloaded');
  };

  $scope.$on('reloadRoute', $scope.reload);

  const downloadReport = (data) => {
    MessagesService.dialogCustom(
      `O relatório ${data.name} está pronto para download`,
      `<span class="text-center exportador-download-btn">
        <a href="${SERVER}${data.url}" target="_blank" rel="noopener noreferrer">
          Baixar <i class="fa fa-download"></i>
        </a>
      </span>`,
      [{ label: 'Cancelar', className: 'btn-default' }]
    );
  };

  const errorReport = (data) => {
    MessagesService.alert(
      `O processamento do relatório ${data.name} falhou, tente novamente.`
    );
  };

  $scope.$on('terminou_exportador', (_event, data) => {
    downloadReport(data);
  });

  $scope.$on('falhou_exportador', (_event, data) => {
    errorReport(data);
  });

  $scope.$on('terminou_fechamento', (_event, data) => {
    downloadReport(data);
  });

  $scope.$on('falhou_fechamento', (_event, data) => {
    errorReport(data);
  });

  $rootScope.initializePromise = $q.defer();
  $rootScope.initialize = $rootScope.initializePromise.promise;
  if (!window.SERVER) {
    ApiGlobalService.getConfiguration().then(function(url) {
      window.SERVER = url;
      $rootScope.initWeb();
    }, function(error) {
      console.error('Falha ao carregar configuração global.', error);
      LoadingService.hideLoading();
      $location.path('/404');
    });
  } else {
    $rootScope.initWeb();
  }

  const updateNotificacao = function(item, tipo = 'recomendacoes') {
    const lista = $scope.notificacoes[tipo];
    const index = lista.findIndex((n) => n.id === item.id);

    if (index !== -1) {
      if (item.situacao === 'aprovado' || item.situacao === 'rejeitado') {
        lista.splice(index, 1);
      } else {
        lista[index].situacao = item.situacao;
      }
      $scope.$applyAsync();
    }
  };

  $scope.formatMomentDate = function(date, format = DATE_FORMAT.toUpperCase()) {
    return moment(date).format(format);
  };

  function baseAprove($event, item) {
    $event.preventDefault();
    $event.stopPropagation();
    item.loaderAprove = true;
  }

  function validaProdutos(produtos) {
    let ok = true;
    (produtos || []).forEach((produto) => {
      if (produto.dose < 0) {
        ok = false;
      }
    });
    return ok;
  }

  // eslint-disable-next-line max-lines-per-function, complexity, max-lines-per-function
  $scope.aproveApplication = async function($event, aplicacao) {
    baseAprove($event, aplicacao);

    try {
      if (validaProdutos(aplicacao.produtos)) {
        await AuditoriaAplicacaoService.aprove(aplicacao);
        $uibModalStack.dismissAll();

        if (aplicacao.tipo_operacao_enum === 'operacao_semeadura') {
          const messages = await ItensEstoqueService.checkSaldoSementeBranca(aplicacao.produtos);
          messages && MessagesService.alert(`Atenção: <br>${messages.join('<br>')}`);
        }

        aplicacao.situacao = 'aprovado';
        aplicacao.loaderAprove = false;
        updateNotificacao(aplicacao, 'aplicacoes');
        $uibModalStack.dismissAll();
      } else {
        MessagesService.alert('Todos produtos da aplicação devem ter dose positiva!');
      }
    } catch (error) {
      console.error('Erro ao aprovar aplicação:', error);

      if (error) {
        let message = 'Falha ao aprovar aplicação, tente novamente.';

        if (_.get(error.data, 'type') === 'CustomException') {
          message = `Falha ao aprovar aplicação: ${_.get(error.data, 'message')}`;
        } else if (_.isArray(error.data) && error.data[0].id) {
          $rootScope.openPreviousApplicationModal(error);
          return;
        } else if (error.data) {
          message = `Falha ao aprovar aplicação: ${error.data}`;
        }

        $uibModalStack.dismissAll();
        MessagesService.alert(message);
      }
    } finally {
      aplicacao.loaderAprove = false;
      $scope.$applyAsync();
    }
  };

  $scope.aproveRecomendation = function($event, recomendacao) {
    baseAprove($event, recomendacao);

    RecomendacoesService.aprove(recomendacao).then(function() {
      recomendacao.situacao = 'aprovado';
      recomendacao.loaderAprove = false;
      updateNotificacao(recomendacao, 'recomendacoes');
      $scope.$broadcast('update_recomendacao', recomendacao);
    }, function(error) {
      const message = (error && error.data && error.data.message) || 'Falha ao aprovar recomendação, tente novamente.';
      MessagesService.alert(message);
    })
      .finally(function() {
        recomendacao.loaderAprove = false;
      });
  };

  $scope.aproveAqilaRecomendation = function($event, recomendacao) {
    baseAprove($event, recomendacao);

    RecomendacoesService.aproveAqilaRecomendation(recomendacao).then(function() {
      recomendacao.loaderAprove = false;
      recomendacao.situacao = 'aprovado';
      updateNotificacao(recomendacao, 'aqila_recomendacoes');
      $scope.$broadcast('update_recomendacao', recomendacao);
    }, function(error) {
      const message = (error && error.data && error.data.message) || 'Falha ao aprovar recomendação, tente novamente.';
      MessagesService.alert(message);
    })
      .finally(function() {
        recomendacao.loaderAprove = false;
      });
  };

  $rootScope.rejectRecomendation = function($event, recomendacao) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }

    const deferred = $q.defer();

    MessagesService.prompt('Motivo da rejeição').then(function(result) {
      recomendacao.motivo_rejeicao = result;
      recomendacao.loaderReject = true;
      RecomendacoesService.reject(recomendacao).then(function() {
        recomendacao.situacao = 'rejeitado';
        updateNotificacao(recomendacao, 'recomendacoes');
        $scope.$broadcast('update_recomendacao', recomendacao);
        deferred.resolve();
      }, function() {
        MessagesService.alert('Falha ao rejeitar recomendação, tente novamente.');
        deferred.reject();
      })
        .finally(function() {
          recomendacao.loaderReject = false;
        });
    }, deferred.reject);

    return deferred.promise;
  };

  $rootScope.rejectAqilaRecomendation = function($event, recomendacao) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }

    const deferred = $q.defer();

    MessagesService.prompt('Motivo da rejeição').then(function(result) {
      recomendacao.motivo_rejeicao = result;
      recomendacao.loaderReject = true;
      RecomendacoesService.rejectAqilaRecomendation(recomendacao).then(function() {
        recomendacao.situacao = 'rejeitado';
        updateNotificacao(recomendacao, 'aqila_recomendacoes');
        $scope.$broadcast('update_recomendacao', recomendacao);
        deferred.resolve();
      }, function() {
        MessagesService.alert('Falha ao rejeitar recomendação, tente novamente.');
        deferred.reject();
      })
        .finally(function() {
          recomendacao.loaderReject = false;
        });
    }, deferred.reject);

    return deferred.promise;
  };

  $scope.goToRecomendacao = function(recomendacao) {
    $rootScope.initState = {
      event: 'addRecommendation',
      rightSide: 'addRecommendation',
      params: recomendacao
    };

    if (!$rootScope.currentPropriedade || $rootScope.currentPropriedade.id !== recomendacao.propriedade.id) {
      $rootScope.setPropriedade(recomendacao.propriedade.id);
    }
    $timeout(function() {
      $location
        .path('/propriedade')
        .search({
          ...$routeParams,
          activeGleba: null,
          sidebar: 'addRecommendation',
          propriedade: recomendacao.propriedade.id
        });
    });
  };

  // eslint-disable-next-line max-lines-per-function
  $scope.goToAqilaRecomendacao = function(recomendacao) {
    let event = 'addRecommendation';
    let active = 'recomendacao';
    if (recomendacao.operacao.id === 3) {
      event = 'addRecommendationAdubacao';
      active = 'adubacao';
    }
    if (recomendacao.operacao.id === 11) {
      event = 'addRecommendationCorrecao';
      active = 'correcaoSolo';
    }
    $rootScope.initState = {
      event: event,
      rightSide: event,
      params: recomendacao
    };

    if (!$rootScope.currentPropriedade || $rootScope.currentPropriedade.id !== recomendacao.propriedade.id) {
      $rootScope.setPropriedade(recomendacao.propriedade.id);
    }
    $timeout(function() {
      $location
        .path('/propriedade')
        .search({
          ...$routeParams,
          sidebar: event,
          activeGleba: null,
          activeRecommendationsTab: active,
          propriedade: recomendacao.propriedade.id
        });
    });
  };

  $scope.goToAplicacao = function(aplicacao) {
    $rootScope.initState = {
      event: 'edicaoAuditoriaAplicacao',
      rightSide: 'edicaoAuditoriaAplicacao',
      params: aplicacao
    };

    if (!$rootScope.currentPropriedade || $rootScope.currentPropriedade.id !== aplicacao.propriedade.id) {
      $rootScope.setPropriedade(aplicacao.propriedade.id);
    }
    $timeout(function() {
      $location
        .path('/propriedade')
        .search({
          ...$routeParams,
          sidebar: 'edicaoAuditoriaAplicacao',
          activeGleba: null,
          propriedade: aplicacao.propriedade.id,
          activeAuditoriaAplicacao: aplicacao.id
        });
    });
  };

  $scope.openAssistant = function() {
    $uibModal.open({
      templateUrl: 'views/painel_propriedade/aplicacao/assistente_auditoria.html',
      controller: 'AsistenteAuditoriaCtrl',
      controllerAs: '$ctrl',
      resolve: {
        aplicacoes: () => $scope.notificacoes.aplicacoes
      }
    });
  };

  $scope.reportDemandaUso = function() {
    $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'modal-report-demanda-uso-notificacoes.html',
      controller: 'DemandaUsoInsumosCtrl',
      controllerAs: 'DemandaUsoInsumos',
      resolve: {
        operacao: function() {
          return $rootScope.parametros.operacao_pulverizacao;
        },
        cronograma: function() {
          return false;
        },
        aguardandoAprovacao: function() {
          return true;
        },
        aplicacoes: () => $scope.notificacoes.aplicacoes
      }
    });
  };

  $scope.aplicacaoOptions = function(aplicacao) {
    $uibModal.open({
      templateUrl: 'views/aplicacoes/fluxo_apropriacao_aplicacao.html',
      controller: 'FluxoApropriacaoAplicacaoCtrl',
      controllerAs: '$apropriacaoModal',
      resolve: {
        aplicacao: aplicacao
      }
    });
  };

  $rootScope.openPreviousApplicationModal = function(error) {
    $scope.aplicacoesPrevias = error.data.map(function(item) {
      const found = _.find($scope.notificacoes.aplicacoes, { id: item.id });
      return {
        responseFromApi: item,
        aplicacao: found
      };
    });

    return $scope.previousApplicationModal = $uibModal.open({
      templateUrl: 'views/painel_propriedade/aplicacao/modal_aprovacao_auditoria.html',
      controller: 'AuditoriaAplicacoesPreviasCtrl',
      controllerAs: '$ctrl',
      resolve: {
        aplicacoesPrevias: () => $scope.aplicacoesPrevias
      }
    });
  };

  $rootScope.openImageLightBox = function(images, index) {
    if (images) {
      Lightbox.openModal(images, index || 0);
    }
  };

  $rootScope.errorRootInitialize = function() {
    $location.path('/');
    LoadingService.hideLoading();
  };

  $rootScope.isMasterUser = function() {
    return $rootScope.currentUser && $rootScope.currentUser.nome.toLowerCase() === 'inovacao';
  };

  $rootScope.$on(EVENT_RELOAD_NOTIFICATIONS, loadNotificacoes);

  $rootScope.initialize.then(function() {
    $timeout(function() {
      $('#dropdownNotificacoes').on('show.bs.dropdown', function() {
        loadNotificacoes();
      });

      $('#dropdownNotificacoes').on('hide.bs.dropdown', function() {
        $rootScope.filterNotifications = '';
        $rootScope.$apply();
      });

      $('#dropdownPropriedades').on('hide.bs.dropdown', function() {
        $scope.filterProperty = '';
        $scope.$apply();
      });
    });
  });
});
